"use client"

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"

import { apiClient } from "@/lib/api/client"
import { apiUrl } from "@/lib/api/url"
import { userKeys } from "@/lib/nango.user/keys/user"

import { User } from "@/nango/types/nango.user/user/User"

const USER_URL = "api/user/user/"

export function useCurrentUser(enabled: boolean = true) {
  return useQuery({
    queryKey: userKeys.me(),
    queryFn: () =>
      apiClient<User>({
        url: apiUrl(USER_URL),
        method: "GET",
      }),
    enabled,
  })
}

export type UpdateUserPayload = {
  first_name?: string
  last_name?: string
  phone_number?: string
  gender?: string
}

export function useUpdateUser(userId: number) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: UpdateUserPayload) =>
      apiClient<User>({
        url: apiUrl(`${USER_URL}${userId}/`),
        method: "PATCH",
        data,
      }),
    onSuccess: (user) => {
      queryClient.setQueryData(userKeys.me(), user)
    },
  })
}
